module.exports = __webpack_public_path__ + "kameon-icons.4f96bb4272740fa329c7.eot";


//////////////////
// WEBPACK FOOTER
// C:/GIT/kameon.gdpr/ui/src/assets/fonts/kameon-icons.eot
// module id = ../../../../../src/assets/fonts/kameon-icons.eot
// module chunks = styles